"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-leucio-del-sannio": {
    "71c25eba": [{
      "hkey": "1610e439",
      "slug": "san-leucio-del-sannio-cavuoti",
      "name": "San Leucio del Sannio-Cavuoti",
      "primary": true,
      "skipSearch": false
    }],
    "aggregati-cavuoti": [{
      "hkey": "1610e439",
      "slug": "san-leucio-del-sannio-cavuoti",
      "name": "San Leucio del Sannio-Cavuoti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7cbe2704": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "amicoli": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f624be2": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "ariarella": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38cc675c": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "confini": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4c5c251": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "facchiani": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "341f8539": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "feleppi": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2b73693": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "fievo": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c0201da": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "piano-alfieri": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90b00305": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "pietrizolli": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65a4e1b2": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4812863c": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "vardaro-alvanelle": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34311144": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "verdini": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad18bc86": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "zolli": [{
      "hkey": "1e6f328c",
      "slug": "san-leucio-del-sannio",
      "name": "San Leucio del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;